import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { isProUser } from "./entitlements";

export async function getFeaturedBuild() {
  const snapshot = await getDocs(collection(db, "profiles"));

  const builds = [];

  snapshot.forEach((docItem) => {
    const profile = docItem.data();

    const username = profile.username || docItem.id;
    const cars = profile.garageCars || [];

    cars.forEach((car) => {
      const image = car.images?.[0] || null;

      const eligible =
        image &&
        car.year &&
        car.make &&
        car.model &&
        car.id &&
        username;

      if (eligible) {
        builds.push({
          id: car.id,
          username,
          image,
          title: `${car.year} ${car.make} ${car.model}`,
          ownerIsPro: isProUser(profile),
        });
      }
    });
  });

  if (!builds.length) {
    return null;
  }

  const today = new Date().toISOString().split("T")[0];

  const seed = getSeed(today);

  const shuffled = seededShuffle(builds, seed);

  return shuffled[0];
}

function getSeed(text) {
  let seed = 0;

  for (let i = 0; i < text.length; i++) {
    seed = (seed * 31 + text.charCodeAt(i)) >>> 0;
  }

  return seed;
}

function seededShuffle(array, seed) {
  const shuffled = [...array];

  let currentSeed = seed;

  for (let i = shuffled.length - 1; i > 0; i--) {
    currentSeed = (currentSeed * 1664525 + 1013904223) >>> 0;

    const randomIndex = currentSeed % (i + 1);

    [shuffled[i], shuffled[randomIndex]] = [
      shuffled[randomIndex],
      shuffled[i],
    ];
  }

  return shuffled;
}
